export class SocketRooms {
  public static readonly ACCESS_MANAGER_ROOM: string = 'AccessManagerRoom';
  public static readonly QR_GENERATOR_ROOM: string = 'QRGeneratorRoom';
  public static readonly KIOSK_ROOM: string = 'KioskRoom';
  public static readonly LOADER_ROOM: string = 'LoaderRoom';

  public static readonly ROOMS: string[] = [
    SocketRooms.ACCESS_MANAGER_ROOM,
    SocketRooms.QR_GENERATOR_ROOM,
    SocketRooms.KIOSK_ROOM,
    SocketRooms.LOADER_ROOM,
  ];
}
